import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./EnforcementsFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import EnforcementsFormStepOne from "./EnforcementsFormSteps/EnforcementsFormStepOne";
import { useEffect, useState } from "react";

const EnforcementsForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        contact: _initialValues?.contact?.uuid
          ? {
              ..._initialValues?.contact,
              label: _initialValues?.contact?.name,
              uuid: _initialValues?.contact?.uuid,
            }
          : null,
        representative: _initialValues?.representative?.uuid
          ? {
              ..._initialValues?.representative,
              label: `${_initialValues?.representative?.name} ${_initialValues?.representative?.lastname}`,
              uuid: _initialValues?.representative?.uuid,
            }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="EnforcementsForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <EnforcementsFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default EnforcementsForm;
